import { useMemo } from "react";
import { useLocation } from "react-router-dom";

function useQueryParams() {
    const location = useLocation();
    const { search } = location;
    return useMemo(() => new URLSearchParams(search), [search]);
}

export default useQueryParams;
